exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dropdown-item {\n    background: transparent;\n    transform-origin: top;\n    position: relative;\n    color:#040405;\n    animation-name: example;\n    animation-duration: 1s;\n    animation-iteration-count: 1;\n    animation-direction: alternate;\n}\n.bounce-enter-active {\n    /* zoom: 1; */\n    transform-origin: top right;\n    margin-top: 5px;\n    animation: bounce-in 0.4s;\n}\n.bounce-leave-active {\n     animation: bounce-in 1s reverse;\n}\n@keyframes example {\n0% {color: #FFFFFF;}\n100% {color:#040405;}\n}\n@keyframes bounce-in {\nfrom { transform: scale(0);\n}\nto {\n}\n}\n", ""]);

// exports
